<style lang="stylus">
    .home {
        .info-list {
            padding 12px 18px
            li {
                display inline-block
                box-sizing border-box
                width 50%
                padding-left: 12px
                margin 12px 0
                border-left 2px solid #50C7B6
                &:nth-child(2n+1) {
                    border-color #1EA4BC
                }
                p {
                    margin 0
                    &.title {
                        font-size:12px
                        color: #A5A5A5
                    }
                    &.value {
                        font-size:16px
                        color: #fff
                        padding-top: 6px
                    }
                }
            }
            .van-cell {
                &:nth-of-type(2n) {
                    i {
                        color: #F2912B
                    }
                }
                &:nth-of-type(2n+1) {
                    i {
                        color: #14AFD8
                    }
                }
            }
        }
    }
</style>
<style scoped lang="stylus">
    @import '../../assets/css/theme.styl'
    .home {
        /*padding 20px 0*/
        .van-cell-group {
            background-color: transparent
            &:after {
                border-bottom-color #333
                border-top-color #333
            }
        }

        .top {
            color: #fff
            padding 18px 18px 0
            /*text-align center*/
            p, h2 {
                margin 0
            }
            p {
                font-size:18px
                i {
                    color: #41E1F0
                    margin-right: 8px
                }
            }
            h2 {
                font-size:24px
                color: #80DCBB
                margin: 10px 0;
            }
            & > div {
                background rgba(80,199,182, .18)
                padding 4px 10px
                display inline-flex
                span {
                    color: #fff
                    &:first-child {
                        margin-right: 12px
                        font-size: 14px
                    }
                    &:last-child {
                        font-size: 16px
                        /*color: #14AFD8*/
                    }
                }
            }
        }

        .chart-box {
            li {
                background-color: baseConBackColor
                margin 10px 0
            }
            .chart {
                /*background-color: #fff*/
                height: 300px;
                /*margin-top: 20px;*/
                padding-top: 10px
            }
            p.title {
                margin 0
                color: #fff
                font-size:15px
                font-weight: bold
                padding 14px
            }
        }
        .van-popup--right {
            width 100%
            height: 100vh
            box-sizing border-box
            padding 20px 10px
        }
        .van-popup {
            background-color: baseBackColor
        }

        .desc-info {
            padding 10px 10px 0
            .con {
                overflow: hidden
                .data-box {
                    background-color: baseConBackColor
                }
                .left, .right {
                    flex: 1
                }
                .fac-name {
                    font-size: 16px
                    font-weight: bold
                    background-color: #203F49
                    text-align center
                }
            }
        }
    }
</style>

<template>
    <div class="home cus-cell">
        <div class="desc-info">
            <div class="con">
                <QuickTime @time-change="kTimeChange" :is-quick-time="isQuickTime"/>
                <van-cell :title="timeTips" class="time-tips no_border"/>
                <div class="data-box">
                    <div :class="{'card-box': chooseFullFacName}">
                        <van-cell v-show="chooseFullFacName" :title="chooseFullFacName" class="no_border fac-name"/>

                        <div class="top">
                            <p data-flex="cross:center">
                                <van-icon name="setting-o" />
                                出厂吨数
                            </p>
                            <h2>{{countData.out}}</h2>
                            <div data-flex="dir:left cross:center">
                                <span>核验吨数</span>
                                <span>{{countData.check_out}}</span>
                            </div>
                        </div>
                    </div>
                    <ul class="info-list">
                        <!--<van-cell v-for="(item, index) in infoList" :key="index" :title="item.name" :icon="item.icon" :value="item.val" class="no_border" />-->
                        <li v-for="(item, index) in infoList" :key="index">
                            <p class="title">{{item.name}}</p>
                            <p class="value">{{item.val}}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <ul class="chart-box" v-show="!typeIsKa">
                <li>
                    <p class="title">车次统计</p>
                    <div id="num-chart" class="chart" :style="barHeight"></div>
                </li>

                <li>
                    <p class="title">重量统计</p>
                    <div id="weight-chart" class="chart" :style="barHeight"></div>
                </li>

                <li>
                    <p class="title">金额统计</p>
                    <div id="money-chart" class="chart" :style="barHeight"></div>
                </li>

                <li v-if="gtOneDay">
                    <p class="title">统计曲线</p>
                    <div id="bo-chart" class="chart"></div>
                </li>
            </ul>
        </div>



        <van-popup v-model="popShow" position="right">

            <van-field
                    readonly
                    clickable
                    label="类型"
                    :value="type"
                    placeholder="选择类型"
                    @click="typePicker = true"
            />

            <van-field
                    readonly
                    clickable
                    clearable
                    label="开始时间"
                    :value="startTime"
                    placeholder="开始时间"
                    @click="startTimePicker = true"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="结束时间"
                    :value="endTime"
                    placeholder="结束时间"
                    @click="endTimePicker = true"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="厂区"
                    :value="factoryName"
                    placeholder="厂区"
                    @click="facPicker = true"
                    v-show="!isFactory"
            />

            <van-field
                    readonly
                    clickable
                    clearable
                    label="卡口"
                    :value="kaName"
                    placeholder="卡口"
                    @click="kaPicker = true"
                    v-show="typeIsKa"
            />

            <div class="bt-cus-box">
                <van-button type="primary" size="large" @click="searchSubmit">确 定</van-button>
                <van-button type="warning" size="large" @click="resetSearch">重 置</van-button>
                <van-button type="default" size="large" @click="hidePop">取 消</van-button>
            </div>
        </van-popup>

        <van-popup v-model="typePicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择类型"
                    :columns="typeColumns"
                    @cancel="hideType"
                    @confirm="typeConfirm"
            />
        </van-popup>

        <van-popup v-model="facPicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择厂区"
                    :columns="facColumns"
                    @cancel="hideFac"
                    @confirm="facConfirm"
            />
        </van-popup>

        <van-popup v-model="kaPicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择卡口"
                    :columns="kaColumns"
                    @cancel="hideKa"
                    @confirm="kaConfirm"
            />
        </van-popup>

        <van-popup v-model="startTimePicker" position="bottom">
            <van-datetime-picker
                    v-model="startTimeDate"
                    type="datetime"
                    :max-date="maxDate"
                    @confirm="startTimeConfirm"
                    @cancel="hideStartTime"
            />
        </van-popup>

        <van-popup v-model="endTimePicker" position="bottom">
            <van-datetime-picker
                    v-model="endTimeDate"
                    type="datetime"
                    :max-date="maxDate"
                    @confirm="endTimeConfirm"
                    @cancel="hideEndTime"
            />
        </van-popup>
    </div>
</template>

<script>
    import {getListNp as getKaListNp} from "@/service/ka";
    import {getListNp as getFacListNp} from "@/service/fac";
    import {count, boCount} from "@/service/home";
    import dayjs from 'dayjs'
    import echarts from 'echarts'
    import {info} from "@/service/user";
    import _ from 'lodash'
    import QuickTime from '@/components/QuickTime'
    import {mapState} from "vuex";
    import {calcSize} from "@/util";

    export default {
        props: [],
        components: {
            QuickTime,
        },
        data() {
            return {
                infoList: [],
                searchForm: {
                    type: 'out',
                    settlement_time: '',
                    kakou_no: '',
                    factory_id: '',
                },
                countRes: {},
                countData: {
                    out: '',
                    check_out: ''
                },

                numChart: '',
                weightChart: '',
                moneyChart: '',
                interval: '',

                timeTypeList: [
                    {
                        name: '出厂时间',
                        key: 'out',
                    },
                    {
                        name: '过卡口时间',
                        key: 'ka'
                    }
                ],

                preCurrent: '',
                timeVal: [],

                boData: {},
                boChart: '',

                echartFontColor: '#fff',
                echartYLineColor: '#113144',
                echartTopFontColor: '#fff',
                echartXYColor: '#949494',

                popShow: false,
                type: '',
                typePicker: false,
                typeList: [
                    {
                        name: '出厂时间',
                        key: 'out',
                    },
                    {
                        name: '过卡口时间',
                        key: 'ka'
                    }
                ],
                typeColumns: [],

                startTime: '',
                endTime: '',
                startTimeDate: dayjs().toDate(),
                endTimeDate: dayjs().toDate(),
                maxDate: dayjs().endOf('day').toDate(),

                //快捷时间数据
                kType: 'day',
                kTimeStr: '',

                factoryName: '',
                chooseFullFacName: '',
                facPicker: false,
                facColumns: [],
                facList: [],

                kaPicker: false,
                kaName: '',
                kaColumns: [],
                kaList: [],

                startTimePicker: false,
                endTimePicker: false,

                isQuickTime: true,
            };
        },
        created() {

            this.dealTypeData()

            this.getFacList()
            this.getKaList()

            this.interval = setInterval(() => {
                this.getData()
            }, 10000)
        },
        mounted() {
            this.$eventHub.$on('click-right', () => {
                this.showPop()
            })
        },
        computed: {
            ...mapState({
               factoryId: state => state.userInfo.factory_id
            }),
            isFactory() {
                return this.factoryId > 0
            },
            typeIsKa() {
                return this.searchForm.type == 'ka'
            },
            gtOneDay() {
                let time = _.split(this.searchForm.settlement_time, ' - ')
                let day = dayjs(time[1]).diff(dayjs(time[0]), 'day')
                return day >= 1
            },
            searchTimeList() {
                return this.searchForm.settlement_time.split(' - ')
            },
            timeTips() {
                return this.preCurrent == 'day' ? `${this.searchTimeList[0]} - 目前` : this.searchForm.settlement_time
            },
            barHeight() {
                return {
                    height: `${this.countRes.length * 8 + 10}vh`,
                }
            }
        },
        watch: {},
        methods: {
            resetSearch() {
                this.resetTime()
                this.searchForm.factory_id = ''
                this.factoryName = ''
                this.searchForm.kakou_no = ''
                this.kaName = ''
            },
            resetTime() {
                this.kTimeStr = ''
                this.startTime = ''
                this.endTime = ''
            },
            resetType() {
                this.kType = ''
            },
            startTimeConfirm(val) {
                this.startTime = dayjs(val).format('YYYY-MM-DD HH:mm')
                this.resetType()
                this.hideStartTime()
            },
            hideStartTime() {
                this.startTimePicker = false
            },
            hideEndTime() {
                this.endTimePicker = false
            },
            endTimeConfirm(val) {
                this.endTime = dayjs(val).format('YYYY-MM-DD HH:mm')
                this.resetType()
                this.hideEndTime()
            },
            hideKa() {
                this.kaPicker = false
            },
            kaConfirm(val, index) {
                this.kaName = val
                this.searchForm.kakou_no = this.kaList[index].kakou_no
                this.hideKa()
            },
            hideFac() {
                this.facPicker = false
            },
            facConfirm(val, index) {
                this.factoryName = val
                this.searchForm.factory_id = this.facList[index].id
                this.hideFac()
            },
            hideType() {
                this.typePicker = false
            },

            dealTypeData() {
                this.setTypeColumns()
                this.setDefaultType()
            },
            setTypeColumns() {
                this.typeColumns = this.typeList.map(item => {
                    return item.name
                })
            },
            setDefaultType() {
                this.type = this.typeList[0].name
            },
            typeConfirm(val, index) {
                this.searchForm.type = this.typeList[index].key
                this.type = val
                this.hideType()
            },
            searchSubmit() {
                if (this.startTime != '' || this.endTime != '') {
                    if (this.startTime == '') {
                        this.$toast('开始时间不能为空')
                        return
                    }
                    if (this.endTime == '') {
                        this.$toast('结束时间不能为空')
                        return
                    }
                    if (dayjs(this.startTimeDate).isAfter(dayjs(this.endTimeDate))) {
                        this.$toast('开始结束时间不正确')
                        this.searchForm.settlement_time = ''
                        return
                    }
                    this.searchForm.settlement_time = `${this.startTime} - ${this.endTime}`
                    this.preCurrent = ''
                    this.isQuickTime = false
                } else {
                    this.kTimeInit()
                }
                this.setChooseFacName()

                this.search()
                this.hidePop()
            },
            setChooseFacName() {
                let obj = _.find(this.facList, {id: this.searchForm.factory_id})
                this.chooseFullFacName = _.get(obj, 'full_name')
            },
            hidePop() {
                this.popShow = false
            },
            showPop() {
                this.popShow = true
            },
            getData() {
                this.getCountData()
                if (!this.typeIsKa && this.gtOneDay) {
                    this.getBoData()
                }
            },
            async getKaList() {
                let res = await getKaListNp()
                if (res.status) {
                    this.kaList = res.data
                    this.kaColumns = this.kaList.map(item => {
                        return item.kakou_name
                    })
                }
            },
            async getFacList() {
                let res = await getFacListNp()
                if (res.status) {
                    this.facList = res.data
                    this.facColumns = this.facList.map(item => {
                        return item.factory_name
                    })
                }
            },
            kTimeChange({time, type}) {
                this.resetTime()
                this.isQuickTime = true
                this.kType = type
                this.kTimeStr = time
                this.kTimeInit()
                this.search()
            },
            async getBoData() {
                let data = _.clone(this.searchForm)
                if (this.isFactory) data.factory_id = this.factoryId
                let res = await boCount(data)
                if (res.status) {
                    this.boData = res.data
                    this.renderBoChart()
                }
            },

            async getCountData() {
                let data = _.clone(this.searchForm)
                if (this.isFactory) data.factory_id = this.factoryId
                if (this.typeIsKa) {
                    data = _.assign({check_time: this.searchForm.settlement_time}, _.omit(data, ['settlement_time', 'type']))
                } else {
                    data = _.omit(data, ['kakou_no', 'type'])
                }
                let res = await count(data)
                if (res.status) {
                    this.countRes = res.data
                    this.dealCountData(res.data)
                } else {
                    this.$toast(res.info)
                }
            },
            dealCountData(data) {
                let totalNum = [], totalWeight = [], totalMoney = [], checkNum = [], checkWeight = [], checkMoney = []
                data.map(item => {
                    totalNum.push(parseFloat(item.num))
                    totalWeight.push(parseFloat(item.total_weight))
                    totalMoney.push(parseFloat(item.money))
                    checkNum.push(parseFloat(item.checked))
                    checkWeight.push(parseFloat(item.checked_weight))
                    checkMoney.push(parseFloat(item.checked_money))
                })

                this.countData.out = `${_.sum(totalWeight).toFixed(2)}吨`
                this.countData.check_out = `${_.sum(checkWeight).toFixed(2)}吨`

                this.infoList = [
                    {
                        name: '出厂车次',
                        val: `${_.sum(totalNum).toFixed(2)}次`,
                        icon: 'diamond',
                    },
                    {
                        name: '核验车次',
                        val: `${_.sum(checkNum).toFixed(2)}次`,
                        icon: 'diamond',
                    },
                    {
                        name: '出厂金额',
                        val: `${_.sum(totalMoney).toFixed(2)}元`,
                        icon: 'gold-coin',
                    },
                    {
                        name: '核验金额',
                        val: `${_.sum(checkMoney).toFixed(2)}元`,
                        icon: 'gold-coin',
                    }
                ]

                this.$nextTick(() => {
                    this.renderNumChart()
                    this.renderWeightChart()
                    this.renderMoneyChart()
                })
            },
            kTimeInit() {
                this.searchForm.settlement_time = this.kTimeStr
                this.preCurrent = this.kType
            },
            search() {
                this.getData()
            },


            renderBoChart() {
                if (_.isEmpty(this.boData)) return
                let timeList = [], numList = [], weightList = [], moneyList = []
                let typeList = ['总车数', '总吨数', '总金额']
                _.map(this.boData, (item, key) => {
                    let time = _.split(key, '-')
                    timeList.push(`${time[1]}/${time[2]}`)
                    numList.push(item.num)
                    weightList.push(item.total_weight)
                    moneyList.push(item.money)
                })

                let option = {
                    tooltip: {
                        trigger: 'axis',
                        textStyle: {
                            fontSize: calcSize(12),
                        }
                    },
                    color: ['#6BA990', '#1EA4BC', '#ff9900'],
                    legend: {
                        data: typeList,
                        itemWidth: calcSize(25),
                        itemHeight: calcSize(14),
                        textStyle: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        }
                    },
                    grid: {
                        left: 10,
                        right: 40,
                        bottom: 10,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: timeList,
                        axisLabel: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        },
                        splitLine: {
                            lineStyle: {
                                color: this.echartYLineColor,
                            }
                        }
                    },
                    series: [
                        {
                            name: typeList[0],
                            type:'line',
                            smooth: true,
                            data: numList
                        },
                        {
                            name: typeList[1],
                            type:'line',
                            smooth: true,
                            data: weightList
                        },
                        {
                            name: typeList[2],
                            type:'line',
                            smooth: true,
                            data: moneyList
                        }
                    ]
                }
                this.boChart = echarts.init(document.getElementById('bo-chart'))
                this.boChart.setOption(option)
            },

            renderNumChart() {
                let facData = [], outFac = [], outCheck = []
                this.countRes.map(item => {
                    facData.push(item.factory_name)
                    outFac.push(parseInt(item.num))
                    outCheck.push(parseInt(item.checked))
                })

                let option = {
                    color: ['#2d8cf0', '#19be6b'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        textStyle: {
                            fontSize: calcSize(12),
                        }
                    },
                    grid: {
                        left: calcSize(10),
                        right: calcSize(60),
                        bottom: calcSize(10),
                        containLabel: true
                    },
                    legend: {
                        data: ['出厂车次', '核验车次'],
                        itemWidth: calcSize(25),
                        itemHeight: calcSize(14),
                        textStyle: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        }
                    },
                    xAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                color: this.echartXYColor,
                                show: false,
                                fontSize: calcSize(12),
                            },
                            splitLine: {
                                lineStyle: {
                                    color: this.echartYLineColor,
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'category',
                            data: facData,
                            axisLabel: {
                                color: this.echartXYColor,
                                formatter: this.dealChartAxis,
                                fontSize: calcSize(12),
                                interval: 0,
                            },
                        }
                    ],
                    series: [
                        {
                            name: '出厂车次',
                            type: 'bar',
                            data: outFac,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: this.echartTopFontColor,
                                    fontSize: calcSize(12),
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 0,
                                        [
                                            {offset: 0, color: '#6BA990'},
                                            {offset: 1, color: '#80DCBB'},
                                        ]
                                    )
                                },
                            },
                        },
                        {
                            name: '核验车次',
                            type: 'bar',
                            data: outCheck,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: this.echartTopFontColor,
                                    fontSize: calcSize(12),
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 0,
                                        [
                                            {offset: 0, color: '#1EA4BC'},
                                            {offset: 1, color: '#75B6C8'},
                                        ]
                                    )
                                },
                            },
                        }
                    ]
                };
                this.numChart = echarts.init(document.getElementById('num-chart'))
                this.numChart.setOption(option)
                this.numChart.resize()
            },

            renderWeightChart() {
                let facData = [], outFac = [], outCheck = []
                this.countRes.map(item => {
                    facData.push(item.factory_name)
                    outFac.push(item.total_weight)
                    outCheck.push(item.checked_weight)
                })

                let option = {
                    color: ['#2d8cf0', '#19be6b'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        textStyle: {
                            fontSize: calcSize(12),
                        }
                    },
                    grid: {
                        left: calcSize(10),
                        right: calcSize(68),
                        bottom: calcSize(10),
                        containLabel: true
                    },
                    legend: {
                        data: ['出厂吨数', '核验吨数'],
                        itemWidth: calcSize(25),
                        itemHeight: calcSize(14),
                        textStyle: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        }
                    },
                    xAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                color: this.echartXYColor,
                                show: false,
                                fontSize: calcSize(12),
                            },
                            splitLine: {
                                lineStyle: {
                                    color: this.echartYLineColor,
                                    fontSize: calcSize(12),
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'category',
                            data: facData,
                            axisLabel: {
                                color: this.echartXYColor,
                                formatter: this.dealChartAxis,
                                fontSize: calcSize(12),
                                interval: 0,
                            },
                        }
                    ],
                    series: [
                        {
                            name: '出厂吨数',
                            type: 'bar',
                            data: outFac,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: this.echartTopFontColor,
                                    fontSize: calcSize(12),
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 0,
                                        [
                                            {offset: 0, color: '#6BA990'},
                                            {offset: 1, color: '#80DCBB'},
                                        ]
                                    )
                                },
                            },
                        },
                        {
                            name: '核验吨数',
                            type: 'bar',
                            data: outCheck,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: this.echartTopFontColor,
                                    fontSize: calcSize(12),
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 0,
                                        [
                                            {offset: 0, color: '#1EA4BC'},
                                            {offset: 1, color: '#75B6C8'},
                                        ]
                                    )
                                },
                            },
                        }
                    ]
                };
                this.weightChart = echarts.init(document.getElementById('weight-chart'))
                this.weightChart.setOption(option)
                this.weightChart.resize()
            },

            renderMoneyChart() {
                let facData = [], outFac = [], outCheck = []
                this.countRes.map(item => {
                    facData.push(item.factory_name)
                    outFac.push(item.money)
                    outCheck.push(item.checked_money)
                })

                let option = {
                    color: ['#2d8cf0', '#19be6b'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        textStyle: {
                            fontSize: calcSize(12),
                        }
                    },
                    grid: {
                        left: calcSize(10),
                        right: calcSize(68),
                        bottom: calcSize(10),
                        containLabel: true
                    },
                    legend: {
                        data: ['出厂金额', '核验金额'],
                        itemWidth: calcSize(25),
                        itemHeight: calcSize(14),
                        textStyle: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        }
                    },
                    xAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                color: this.echartXYColor,
                                show: false,
                                fontSize: calcSize(12),
                            },
                            splitLine: {
                                lineStyle: {
                                    color: this.echartYLineColor,
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'category',
                            data: facData,
                            axisLabel: {
                                color: this.echartXYColor,
                                formatter: this.dealChartAxis,
                                fontSize: calcSize(12),
                                interval: 0,
                            },
                        }
                    ],
                    series: [
                        {
                            name: '出厂金额',
                            type: 'bar',
                            data: outFac,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: this.echartTopFontColor,
                                    fontSize: calcSize(12),
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 0,
                                        [
                                            {offset: 0, color: '#6BA990'},
                                            {offset: 1, color: '#80DCBB'},
                                        ]
                                    )
                                },
                            },
                        },
                        {
                            name: '核验金额',
                            type: 'bar',
                            data: outCheck,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    color: this.echartTopFontColor,
                                    fontSize: calcSize(12),
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 1, 0,
                                        [
                                            {offset: 0, color: '#1EA4BC'},
                                            {offset: 1, color: '#75B6C8'},
                                        ]
                                    )
                                },
                            },
                        }
                    ]
                };
                this.moneyChart = echarts.init(document.getElementById('money-chart'))
                this.moneyChart.setOption(option)
                this.moneyChart.resize();
            },

            dealChartAxis(value, index) {
                let res = ''
                _.chunk(value, 4).map(item => {
                    res += _.join(item, '') + "\n"
                })
                return res
            }
        },
        destroyed() {
            this.interval && clearInterval(this.interval)
            this.$eventHub.$off()
        },
    };
</script>
